import { render, staticRenderFns } from "./LayoutBackFooter.vue?vue&type=template&id=b5133520&scoped=true&"
import script from "./LayoutBackFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutBackFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBackFooter.vue?vue&type=style&index=0&id=b5133520&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5133520",
  null
  
)

export default component.exports